// extracted by mini-css-extract-plugin
export default {"Container":"HeaderNavigation_Container__7Frd2","ArrowIcon":"HeaderNavigation_ArrowIcon__5klTY"};